// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/JobItemDetails.scss
// module id = ./src/styles/JobItemDetails.scss
// module chunks = 0